import { BaseInput, baseInputClasses, Button } from "@kaltura/ds-react-components";
import { Copy24Icon } from "@kaltura/ds-react-icons";
import { translate } from "@kaltura/mediaspace-shared-utils";
import React from "react";
import styled from "@emotion/styled";
import { FormLabel } from "../form/form-label/FormLabel";

export interface CopyToClipboardInputProps {
    // text to copy
    text: string;
    // label associated with the copy input
    label: string;
    // callback function called when the text is copied
    onCopy?: () => void;
    className?: string;
}

const base_class_name = "copy-to-clipboard";

export const CopyToClipboardInput = ({ text, onCopy, className, label }: CopyToClipboardInputProps) => {
    const copyText = () => {
        navigator.clipboard.writeText(text);
        onCopy?.();
    };

    return (
        <div className={className}>
            <FormLabel text={label} fontWeightBold={true} htmlFor={`${className}-link`} />
            <Container>
                <StyledInput
                    value={text}
                    readOnly={true}
                    name={"clipboard"}
                    className={base_class_name + "-input"}
                    id={`${className}-link`}
                />
                <Button
                    variant={"borderless"}
                    color={"secondary"}
                    startIcon={<Copy24Icon />}
                    onClick={copyText}
                    className={base_class_name + "-copy-button"}
                >
                    {translate("Copy")}
                </Button>
            </Container>
        </div>
    );
};

const Container = styled("div")({
    display: "flex",
});

const StyledInput = styled(BaseInput)(({ theme }) => ({
    flexGrow: 1,
    marginRight: theme.spacing(2),
    [`&.${baseInputClasses.readOnly}`]: {
        borderColor: theme.kaltura.palette.tone4,
    },
}));
